import {h, Component} from 'preact';
import invoke from 'lodash.invoke';
import SearchResultItem from '../SearchResultItem';
import SearchResultsEmpty from '../SearchResultsEmpty';
import List from '../list/List';
import GroupLabel from '../list/GroupLabel';
import SearchResultsPagination from '../SearchResultsPagination';

const SearchResults = ( {
                            activeClass,
                            children,
                            search: {
                                showPagination,
                                resultGroups,
                                queryGroups,
                                query,
                                isFocused,
                                isActive,
                                alwaysShowResults,
                                hasResults,
                                selectedIndex,
                                onVisibleResultsChange,
                                handleResultHover,
                                handleResultClick
                            }
                        } ) => {

    if ( !isActive && !alwaysShowResults ) {
        return;
    }

    if ( !hasResults ) {
        return children[0]( <SearchResultsEmpty/> );
    }

    let index = 0;
    const results = queryGroups.map( ( queryGroup, i ) => {
        const {groupName, renderer} = queryGroup;

        // predicate to determine if queryGroup should be hidden
        if ( invoke( queryGroup, 'hideIf', query, resultGroups ) ) {
            return null;
        }

        const group = resultGroups[i];
        const indexedResults = group.results.map( item => ({
            index: index++,
            queryGroup,
            ...item
        }) );

        return (
            <SearchResultsPagination
                groupIndex={i}
                onResultsChange={onVisibleResultsChange}
                showPagination={showPagination}
                query={query}
                results={indexedResults}
                resultsPerPage={group.resultLimit}>
                {( {pagedResults} ) => (
                    <List data-testid="search-results-list">
                        {groupName && <GroupLabel>{groupName}</GroupLabel>}
                        {pagedResults.map(
                            result =>
                                <SearchResultItem
                                    index={result.index}
                                    key={`SearchResultItem-${result.index}`}
                                    onResultHover={handleResultHover}
                                    onResultClick={handleResultClick}
                                    activeClass={activeClass}
                                    active={selectedIndex === result.index}>
                                    {renderer( result )}
                                </SearchResultItem>
                        )}
                    </List>
                )}
            </SearchResultsPagination>
        );
    } );

    return children[0]( results );
};

export default SearchResults;
